var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6439_207564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0488 3.79587L10.4063 0.105034C10.2824 0.0361509 10.143 0 10.0013 0C9.85957 0 9.72017 0.0361509 9.5963 0.105034L2.9538 3.79587C2.56414 4.01236 2.23945 4.3291 2.01337 4.71328C1.78728 5.09746 1.66803 5.5351 1.66797 5.98087V15.8334C1.66929 16.938 2.1087 17.9971 2.88982 18.7782C3.67093 19.5593 4.72997 19.9987 5.83464 20H14.168C15.2726 19.9987 16.3317 19.5593 17.1128 18.7782C17.8939 17.9971 18.3333 16.938 18.3346 15.8334V5.98087C18.3346 5.5351 18.2153 5.09746 17.9892 4.71328C17.7632 4.3291 17.4385 4.01236 17.0488 3.79587ZM16.668 15.8334C16.668 16.4964 16.4046 17.1323 15.9357 17.6011C15.4669 18.07 14.831 18.3334 14.168 18.3334H5.83464C5.17159 18.3334 4.53571 18.07 4.06687 17.6011C3.59803 17.1323 3.33464 16.4964 3.33464 15.8334V5.98087C3.33427 5.8318 3.37389 5.68536 3.44937 5.55682C3.52486 5.42827 3.63344 5.32233 3.7638 5.25003L10.0013 1.7867L16.2396 5.25003C16.3698 5.32244 16.4783 5.42843 16.5536 5.55697C16.6289 5.6855 16.6684 5.83188 16.668 5.98087V15.8334Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7.08398C10.6904 7.08398 11.25 6.52434 11.25 5.83398C11.25 5.14363 10.6904 4.58398 10 4.58398C9.30964 4.58398 8.75 5.14363 8.75 5.83398C8.75 6.52434 9.30964 7.08398 10 7.08398Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6439_207564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelIcon);
export default __webpack_public_path__ + "static/media/label-icon.742253aa2cd357ed80b1399e946ef0e0.svg";
export { ForwardRef as ReactComponent };